module.exports = __webpack_public_path__ + "static/media/image6.419f00b9.svg";